
















import {Vue, Component, Prop} from 'vue-property-decorator';
import VCRData from "@/components/payroll/vacation/vcr/VCRData.vue";
import {ChangeStatusVCRRequestPayload, VCR, VCRStatus} from "@/dto/payroll/VacationDTO";
import Application from "@/state/Application";
import VacationService from "@/services/payroll/VacationService";
import {processError} from "@/utils/ComponentUtils";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import {ChangeStatusPayload, CreateCommentPayload, SLR, SLRStatus} from "@/components/payroll/sickLeave/slr/SLR_DTO";
import SickLeaveService from "@/services/payroll/SickLeaveService";
import SLRData from "@/components/payroll/sickLeave/slr/SLRData.vue";

@Component({
	computed: {
		SLRStatus() {
			return SLRStatus
		},
		VCRStatus() {
			return VCRStatus
		}
	},
	components: {SLRData, PortalTextarea, VCRData}
})
export default class EmploymentSLR extends Vue {

	@Prop()
	private slr!: SLR

	private comment: string | null = null

	private cancel() {
		Application.startLoading()
		SickLeaveService.cancelRequest(
			new ChangeStatusPayload(
				{
					requestId: this.slr.id,
					employmentId: this.slr.requester.id,
					comment: this.comment
				}
			)
		).then(
			() => {
				this.$modal.hideAll()
				Application.stopLoading()
				this.$emit("cancel")
			},
			err => processError(err, this)
		)
	}

	private sendComment() {
		Application.startLoading()
		SickLeaveService.createComment(
			new CreateCommentPayload(
				{
					requestId: this.slr.id,
					employmentId: this.slr.requester.id,
					comment: this.comment
				}
			)
		).then(
			() => {
				this.$modal.hideAll()
				Application.stopLoading()
				this.$emit("comment")
				this.comment = null
			},
			err => processError(err, this)
		)
	}
}
